import { createContext, type RefObject } from 'react';

export const HistogramChartOverlayRefContext = createContext<
  RefObject<HTMLDivElement | null> | undefined
>(undefined);
